import styled, { css } from 'styled-components';

const MenuItem = /*#__PURE__*/styled('li').attrs({
  role: 'menuitem'
}).withConfig({
  componentId: "sc-storm-ui-30045097__sc-1ruhcn9-0"
})(["list-style-type:none;text-align:start;"]);
MenuItem.displayName = 'MenuItem';
const BaseMenuItemMixin = /*#__PURE__*/css(["", ";background-color:", ";box-sizing:border-box;min-height:", ";padding:1px 11px 0px 11px;position:relative;text-align:start;@supports selector(:focus-visible){:focus{outline:none;background-color:", ";}}:focus-visible{background-color:", ";outline:none;}:hover{background-color:", ";}"], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.dropdown.item.bg, ({
  theme
}) => theme.dropdown.item.minHeight, ({
  theme
}) => theme.dropdown.item.bg, ({
  theme
}) => theme.dropdown.item.bgHover, ({
  theme,
  $disabled
}) => $disabled ? theme.dropdown.item.bg : theme.dropdown.item.bgHover);

export { BaseMenuItemMixin as B, MenuItem as M };
//# sourceMappingURL=MenuItem.styles-3ba07b16.js.map
